<router-outlet></router-outlet>
<ngx-loading [show]="(isLoading$ | async).mode"></ngx-loading>
<span *ngIf="(isLoading$ | async).mode" class="loading-text">{{ (isLoading$ | async).text }}</span>